import styled from 'styled-components';
import { timingDefault } from '../../constants';
export const Wrapper = styled.div `
  /* Set root font size. Spacing tokens for sub components will be relative to this font size. */
  font-size: ${o => o.theme.spacing(3)};
  border: 1px solid ${o => o.theme.color.deprecated.stone};
  border-radius: 4px;
  display: inline-flex;
  padding: ${o => o.theme.spacing(2.25, 4)};
  align-items: center;
  justify-content: center;
`;
export const InputWrapper = styled.div `
  position: relative;
  z-index: 0;
  flex: 1;

  /* Handle focus outline */
  &:focus-within::before {
    content: '';
    position: absolute;
    inset: -1.35em 1.5em;
    background-color: ${o => o.theme.color.fill.background};
    border: 1px solid ${o => o.theme.color.deprecated.stone};
    border-radius: 2px;

    pointer-events: none;
    z-index: -1;
  }
`;
export const Input = styled.input `
  /* Handle value overflow */
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  /* Reset default vendor styles */
  outline: none;
  border: none;
  background: transparent;

  /* Disable vendor input controls */
  appearance: textfield;
  &::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }

  min-width: ${o => (o.fullWidth ? '100%' : '5.25em')};
  max-width: ${o => (o.fullWidth ? '100%' : '5.25em')};
  width: ${o => (o.fullWidth ? '100%' : 'auto')};
  font-size: 1em;
  font-weight: 700;
  text-align: center;
  line-height: 1.25;
  font-family: ${o => o.theme.typography.font.family.sanSerif};
  color: ${o => o.disabled ? o.theme.color.deprecated.stoneDark : o.theme.color.deprecated.obsidian};
`;
export const ControlButton = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.55em;
  cursor: ${o => o['aria-disabled'] && 'not-allowed'};
  /* Apply disable/hover styles to button icons */
  & path {
    transition: ${timingDefault} ease stroke;
    stroke: ${o => !o['aria-disabled'] ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.stoneDark};
  }

  &:hover {
    & path {
      stroke: ${o => !o['aria-disabled'] && o.theme.color.deprecated.obsidianLighter};
    }

    background-color: ${o => o.theme.color.deprecated.stoneLighter};
    border-radius: 4px;
  }
  & > svg {
    width: 0.9em;
    height: 0.9em;
  }
`;
//# sourceMappingURL=styles.js.map